/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import {
  EnigmaClientSettings,
  PerfxClientSettings,
} from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/**
 * ConfigApi - API class
 */
export class ConfigApi extends LinqService {

  /**
   * Creates a new ConfigApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   */
  getClientSettings(options?: QueryOptions) {
    // create query
    const url = `/Config/GetClientSettings`;
    let query = this.createQuery<PerfxClientSettings>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * @param toggle 
   */
  isFeatureEnabled(toggle?: string, options?: QueryOptions) {
    // create query
    const url = `/Config/IsFeatureEnabled`;
    let query = this.createQuery<boolean>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set query parameters
    options.params.push({ key: 'toggle', value: toggle && toggle.toString() });
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
